import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { EntityfieldApi } from '../../sdk/services/custom';
import { LoopBackFilter, } from '../../sdk/models/';
import * as _ from "lodash";
import { CacheService } from 'ng2-cache/ng2-cache';

/*
This custom field is used to select fields for an app.
*/

@Component({
  selector: 'formly-entityfield-selector',
  template: `
   <ng-select *ngIf="items.length > 0"   
              (data)="value"  
             [active]="selectedvalues"
              (data)="refreshValue($event)"
              (selected)="selected($event)"
              (removed)="removed($event)" 
              [items]="items"
              [multiple] = "false"
              [disabled]="to.disabled"
              placeholder="" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
  providers: [EntityfieldApi]
})
export class EntityfieldSelect extends FieldType implements OnInit, OnDestroy {
  _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
  items: any = [];
  selectedvalues: any = [];
  subscriptions: any = [];
  parentEntityId = null;

  constructor(private _EntityfieldApi: EntityfieldApi, private _cacheService: CacheService) {
    super();
  }

  ngOnInit() {

    this.items = [];
    if (this.field["parentEntity"]) {
      this.subscriptions.push(this.form.controls[this.field["parentEntity"]]
        .valueChanges.subscribe((updatedValue: any) => {
          if (updatedValue) {
            this.parentEntityId = updatedValue;
            this.setEntityFields();
          }
        }));
      if (this.model[this.field["parentEntity"]]) {
        this.form.controls[this.field["parentEntity"]].setValue(this.model[this.field["parentEntity"]]);
      }
    } else {
      this.parentEntityId = this.model.entityId;
      this.setEntityFields();
    }
  }

  private setEntityFields() {

    this.items = [];
    //1) Load the drop down values    
    this._loopbackfilter.where = {};
    this._loopbackfilter.where["appId"] = this.model.appId;
    this._loopbackfilter.where["entityId"] = this.parentEntityId;

    //Get the fields for the App
    this.subscriptions.push(this._EntityfieldApi.find(this._loopbackfilter).subscribe((fields) => {
      if (fields) {
        this.items = [];
        for (var i = 0; i < fields.length; i++) {
          if (this.model[this.key] && this.model[this.key]['id'] == fields[i]["id"])
            this.selectedvalues = [{ id: fields[i]["id"], text: fields[i]["label"] }];
          else
            this.items.push({ id: fields[i]["id"], text: fields[i]["label"] });
        }
        this.items = _.sortBy(this.items, 'text');
      }
    }));
  }

  ngOnDestroy() {
    this.selectedvalues = [];
    for (var i = 0; i < this.subscriptions.length; i++) {
      this.subscriptions[i].unsubscribe();
    }
  }

  private value: any = {};

  public selected(value: any): void {
    if (value && value.id)
      this.formControl.setValue(value.id);
  }

  public removed(value: any): void {
    if (value && value.id)
      if (this.model[this.key] && this.model[this.key].length)
        this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
  }

  public typed(value: any): void {

  }

  public refreshValue(value: any): void {
    this.value = value;
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectentityfield.ts